import React, { PureComponent } from 'react'
import { Spin, Button, Form, Select, Row, Col, Input, DatePicker, Switch, message, Radio, Modal, Table } from 'antd'
import moment from 'moment'
import { adminList, pushlist, appPush } from '_src/api/api'
import './style.less'

const { Search } = Input
const { TextArea } = Input
const { RangePicker } = DatePicker
const { Option } = Select

const getType = type => {
  switch (type) {
  case 1:
    return 'H5链接'
  case 2:
    return '商品详情'
  case 3:
    return '旅游详情'
  case 4:
    return '专题页面'
  case 5:
    return '功能模块(页面路径)'
  default:
    return '详情页'
  }
}
const jumpTypes = [
    {id:1,name:'H5链接'},
    {id:2,name:'商品详情'},
    {id:3,name:'旅游详情'},
    {id:4,name:'专题页面'},
    {id:5,name:'功能模块(页面路径)'}
]

@Form.create({ name: '' })
class Push extends PureComponent {
  constructor () {
    super()
    this.state = {
      admins: [],

      isLoading: true,

      params: {
        pageNum: 0,
        pageSize: 10,
      },

      pageData: {
        total: 0,
        current: 1,
      },

      list: [],

      columns: [
        {
          title: '推送标题',
          align: 'center',
          dataIndex: 'title',
          key: 'id',
        },
        {
          title: '内容描述',
          align: 'center',
          dataIndex: 'content',
        },
        {
          title: '推送时间',
          align: 'center',
          dataIndex: 'createAt',
        },
        {
          title: '推送人员',
          align: 'center',
          dataIndex: 'publisher',
        },
        {
          title: '跳转参数',
          align: 'center',
          dataIndex: 'parameters',
          width: 300,
          render: item => <div style={{ wordBreak: 'break-all', width: 500 }}>{item || '无跳转'}</div>
        },
        {
          title: '操作',
          align: 'center',
          width: 150,
          render: item => <div>
            <Button icon="eye" style={{ marginRight: 20 }} onClick={() => this.detail(item.id)}>查看</Button>
          </div>,
        },
      ]

    }
  }
  componentDidMount () {
    adminList().then(res => {
      this.setState({ admins: res.data.content })
    })
    const { params } = this.state
    this.loadList(params)
  }

  loadList (params) {
    this.setState({ isLoading: true })
    pushlist(params)
      .then(res => {
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 搜索标题
  commonChange = (value, key) => {
    const { params } = this.state
    params.pageNum = 0
    if (value) {
      if (key === 'name') {
        const { admins } = this.state
        const cur = admins.filter(item => item.id === value)[0]
        value = cur.name
      }
      params[key] = value
    } else {
      delete params[key]
    }
    this.loadList(params)
  }

  // 时间切换
  timerChange = (e) => {
    const { params } = this.state
    params.pageNum = 0
    if (e.length) {
      params.createStart = moment(e[0]).format('YYYY-MM-DD HH:mm:ss')
      params.createEnd = moment(e[1]).format('YYYY-MM-DD HH:mm:ss')
    } else {
      delete params.createStart
      delete params.createEnd
    }
    this.setState({ params })
    this.loadList(params)
  }

  // 发布推送
  push = () => this.setState({ visible: true, jump: false })

  // 跳转详情判断
  switchChange = (jump) => {
    this.setState({ jump })
  }

  // 查看详情
  detail = (id) => {
    const { list } = this.state
    const obj = list.filter(item => item.id === id)[0]
    if (obj.parameters) {
      let params = JSON.parse(obj.parameters)
      obj.params = params
      obj.keys = Object.keys(params)
    }
    this.setState({
      detailInfo: obj,
      DetailVisible: true,
    })
  }

  deteilModal (info) {
    return (
      <Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
        <Form.Item label="推送人员：" className='flex'>
          <Input value={info.publisher} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="推送时间：" className='flex'>
          <Input value={info.createAt} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="推送标题：" className='flex'>
          <Input value={info.title} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="描述内容：" className='flex'>
          <Input value={info.content} style={{ width: 300 }} readOnly />
        </Form.Item>
        <Form.Item label="是否跳转内容" className='flex'>
          <Switch checked={!!info.parameters} checkedChildren="有详情" unCheckedChildren="无详情" />
        </Form.Item>
        {
          info.keys && (
            <Form.Item label="跳转类型" className='flex'>
              <Input value={getType(info.type)} style={{ width: 300 }} />
            </Form.Item>
          )
        }
        {
          info.keys && (
            <Form.Item label="跳转参数" className='flex'>
              <TextArea value={info.params[info.keys[0]]} style={{ width: 300, height: 80 }} autosize={false} readOnly />
            </Form.Item>
          )
        }
      </Form>
    )
  }

  // 提交创建详情
  handleSubmit = (e) => {
    const _this = this
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const param = {
          title: values.title,
          content: values.content,
          type: values.type?values.type:null
        }
        if (values.jump) {
          const pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
          if (values.type === 1 && !pattern.test(values.value)) {
            message.error('跳转链接地址不正确')
            return
          }
          param.parameters = {
            link: values.value
          }
        }
        const hide = message.loading('发布推送中', 0)
        appPush(param)
          .then(res => {
            const { params } = _this.state
            params.pageNum = 0
            _this.setState({ visible: false })
            hide()
            message.success('推送成功！', 1.2, () => {
              _this.loadList(params)
            })
        }).catch( err => {
            _this.setState({ visible: false })
            hide()
           console.log(err)
        })
      }
    })
  }

  render () {
    const { admins, isLoading, columns, list, pageData, visible, jump, detailInfo, DetailVisible } = this.state
    const { getFieldDecorator } = this.props.form
    return (
      <div className="push-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <Row style={{ paddingBottom: 20 }}>
          <Col lg={{ span: 8 }} style={{ width: 180, marginBottom: 20 }} className="flex-h-a">
            <Button className='creat-station' type="primary" icon="plus" style={{ width: 130 }} onClick={this.push}>发布推送</Button>
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 340, marginBottom: 20 }} className="flex-h-a">
            <span>推送标题：</span>
            <Search style={{ width: 230 }} placeholder="消息标题搜索" onSearch={(e) => this.commonChange(e, 'title')} enterButton />
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 280, marginBottom: 20 }} className="flex-h-a">
            <span>发布人员：</span>
            <Select style={{ width: 180 }} defaultValue='' onChange={(e) => this.commonChange(e, 'name')}>
              <Option value='' key={0}>全部</Option>
              {admins.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
            </Select>
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 320, marginBottom: 20 }} className="flex-h-a">
            <span>发布时间：</span>
            <RangePicker style={{ width: 220 }} onChange={this.timerChange} />
          </Col>
        </Row>

        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }

        <Modal
          title='发布推送'
          visible={visible}
          onCancel={() => this.setState({ visible: false, jump: false })}
          width={600}
          footer={false}
          destroyOnClose
        >
          <Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
            <Form.Item label="推送标题：" className='flex'>
              {getFieldDecorator('title', {
                rules: [{
                  required: true,
                  message: '请输入推送标题',
                }],
              })(
                <Input placeholder="推送标题" style={{ width: 300 }} />
              )}
            </Form.Item>
            <Form.Item label="描述内容：" className='flex'>
              {getFieldDecorator('content', {
                rules: [{
                  required: true,
                  message: '请输入描述内容',
                }],
              })(
                <Input placeholder="描述内容" style={{ width: 300 }} />
              )}
            </Form.Item>
            <Form.Item label="是否跳转内容" className='flex'>
              {getFieldDecorator('jump', {
                initialValue: false,
              })(
                <Switch checkedChildren="有详情" unCheckedChildren="无详情" onChange={this.switchChange} />
              )}
            </Form.Item>
            {
              jump && (
                <Form.Item label="跳转类型" className='flex'>
                  {getFieldDecorator('type', {
                    rules: [{
                      required: true,
                      message: '请选择跳转类型',
                    }],
                  })(
                    <Select placeholder="请选择跳转类型" style={{ width: 180 }}>
                    {
                      jumpTypes.map((item, index) => {
                        return (<Option key={index} value={item.id}>{item.name}</Option>)
                      })
                    }
                  </Select>
                  )}
                </Form.Item>
              )
            }
            {
              jump && (
                <Form.Item label="跳转参数" className='flex'>
                  {getFieldDecorator('value', {
                    rules: [{
                      required: true,
                      message: '请输入跳转参数',
                    }],
                  })(
                    <TextArea placeholder="跳转参数" style={{ width: 300, height: 80 }} autosize={false} />
                  )}
                </Form.Item>
              )
            }
            <Form.Item>
              <Button type="primary" htmlType="submit" size='large' style={{ width: 300, marginLeft: 100, marginTop: 0 }}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>

        <Modal
          title='推送详情'
          visible={DetailVisible}
          onCancel={() => this.setState({ DetailVisible: false })}
          width={600}
          footer={false}
          destroyOnClose
        >
          {detailInfo && this.deteilModal(detailInfo)}
        </Modal>
      </div>
    )
  }
}

export default Push